<p-dialog
  [(visible)]="visible"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  [closable]="true"
  [header]="dialogTitle"
  [appendTo]="'body'"
  [styleClass]="'user-dialog'"
>
  <ng-template pTemplate="header">
    <div class="dialog-header" [attr.data-subtitle]="isEditing ? ('users.crud.subtitle.edit' | transloco) : ('users.crud.subtitle.new' | transloco)">
      <span class="dialog-title">{{ dialogTitle }}</span>
    </div>
  </ng-template>

  <form [formGroup]="userForm" (ngSubmit)="onSubmit()" (keydown.enter)="submitOnEnterSafe($event)" class="form-container">
    <div class="form-group">
      <!-- Basic Information Section -->
      <div class="form-section">
        <h3 class="section-title">{{ 'users.crud.sections.basicInfo' | transloco }}</h3>

        <div class="form-row">
          <div class="form-field">
            <app-input
              [label]="'users.crud.fields.name' | transloco"
              [placeholder]="'users.crud.placeholders.name' | transloco"
              formControlName="name"
              [required]="true"
              [error]="!!userForm.get('name')?.invalid && !!userForm.get('name')?.touched"
              [errorMessage]="getErrorMessage('name') || ''"
              size="medium"
            ></app-input>
          </div>

          <div class="form-field">
            <app-input
              [label]="'users.crud.fields.lastName' | transloco"
              [placeholder]="'users.crud.placeholders.lastName' | transloco"
              formControlName="lastName"
              [required]="true"
              [error]="!!userForm.get('lastName')?.invalid && !!userForm.get('lastName')?.touched"
              [errorMessage]="getErrorMessage('lastName') || ''"
              size="medium"
            ></app-input>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field">
            <app-input
              [label]="'users.crud.fields.lastName2' | transloco"
              [placeholder]="'users.crud.placeholders.lastName2' | transloco"
              formControlName="lastName2"
              size="medium"
            ></app-input>
          </div>

          <div class="form-field">
            <app-input
              [label]="'users.crud.fields.email' | transloco"
              [placeholder]="'users.crud.placeholders.email' | transloco"
              formControlName="email"
              [required]="true"
              [error]="!!userForm.get('email')?.invalid && !!userForm.get('email')?.touched"
              [errorMessage]="getErrorMessage('email') || ''"
              size="medium"
            ></app-input>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field">
            <app-phone
              [label]="'users.crud.fields.phone'"
              formControlName="phone"
              size="medium"
            ></app-phone>
          </div>

          @if (!isEditing) {
            <div class="form-field">
              <app-input
                type="password"
                [label]="'users.crud.fields.password' | transloco"
                [placeholder]="'users.crud.placeholders.password' | transloco"
                formControlName="password"
                [required]="true"
                [error]="!!userForm.get('password')?.invalid && !!userForm.get('password')?.touched"
                [errorMessage]="getErrorMessage('password') || ''"
                size="medium"
              ></app-input>
            </div>
          } @else if (requiresCurrentPassword) {
            <div class="form-field">
              <app-input
                type="password"
                [label]="'users.crud.fields.currentPassword' | transloco"
                [placeholder]="'users.crud.placeholders.currentPassword' | transloco"
                formControlName="currentPassword"
                [required]="true"
                [error]="!!userForm.get('currentPassword')?.invalid && !!userForm.get('currentPassword')?.touched"
                [errorMessage]="getErrorMessage('currentPassword') || ''"
                [helperText]="'users.crud.hints.currentPassword' | transloco"
                size="medium"
              ></app-input>
            </div>
          }
        </div>
      </div>

      <!-- User Configuration Section -->
      <div class="form-section">
        <h3 class="section-title">{{ 'users.crud.sections.configuration' | transloco }}</h3>

        <div class="form-row">
          <div class="form-field">
            <app-select
              [label]="'users.crud.fields.role' | transloco"
              [options]="roleOptions"
              formControlName="roleId"
              [required]="true"
              [placeholder]="'users.crud.placeholders.role' | transloco"
              [error]="!!userForm.get('roleId')?.invalid && !!userForm.get('roleId')?.touched"
              [errorMessage]="getErrorMessage('roleId') || ''"
              size="medium"
              [appendTo]="null"
            ></app-select>
          </div>

          <div class="form-field">
            <label class="field-label">
              {{ 'users.crud.fields.banUser' | transloco }}
              <span [class]="userForm.get('banned')?.value ? 'status-banned' : 'status-active'">
                ({{ userForm.get('banned')?.value ? ('users.crud.fields.banned' | transloco) : ('users.crud.fields.active' | transloco) }})
              </span>
            </label>
            <app-toggle-switch
              formControlName="banned"
            ></app-toggle-switch>
          </div>
        </div>
      </div>
    </div>

    <!-- Form Actions -->
    <div class="form-actions">
      <app-button
        [label]="actionButtonLabel"
        type="submit"
        size="medium"
        [disabled]="isLoading"
        [loading]="isLoading"
        class="submit-button"
      ></app-button>
    </div>
  </form>
</p-dialog>
